import React, { useEffect, useState } from "react";
import { Route } from "react-router-dom/cjs/react-router-dom.min";
import { ToastContainer, toast } from "react-toastify";
import TopHeader from "./TopHeader";
import LeftSidebar from "./LeftSidebar";
import { thirdparty } from "../..";
import { IMAGE_URL } from "../../constants";

const uploading = () => {
  const [fatchdata_1, setFatchdata_1] = useState([]);
  const [fatchdata_2, setFatchdata_2] = useState([]);
  const [formData, setFormData] = useState({
    // type:"news_feature_video",
    upload_file: null,
    value: null,
    // file_path:"",
    // forign_table:"",
    // forign_id:"",
    status: 1,
  });
  if (formData.upload_file) {
    console.log(formData.upload_file.name);
  }

  const handleFileChange = (e) => {
    const file = e.target.files[0];

    // Check if a file was selected
    if (file) {
      // Update the formData state by setting the author_profile_pic to the selected file
      setFormData({
        ...formData,
        upload_file: file,
      });
    }
  };
  const handleSubmit = async (e, $id) => {
    e.preventDefault();
    console.log(formData, "hello");
    if ($id == 2) {
      setFormData({ ...formData, upload_file: null });
    }
    try {
      const response = await thirdparty.post("/settings_update/" + $id, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });
      if (response.status === 200) {
        toast.success("Video Uploading JCI successfully!", {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 3000,
        });
        fetchData($id);
      }

    } catch (error) {
      console.error("Error submitting form:", error);
    }
  };

  useEffect(() => {
    fetchData(1); // Initial data fetch
    fetchData(2); // Initial data fetch
  }, []);
  const fetchData = async ($id) => {
    try {
      const response = await thirdparty.get("/settings/" + $id); // Update the API endpoint

      if (response.status === 200) {
        if ($id == 1) {
          setFatchdata_1(response.data);
        }

        if ($id == 2) {
          setFatchdata_2(response.data);
          setFormData({ ...formData, value: response.data.value })
        }
      }
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  };
  return (
    <div className="fixed-left">
      <div id="wrapper">
        <Route component={LeftSidebar} />
        <div className="content-page">
          <div className="content">
            <Route component={TopHeader} />
            <div className="page-content-wrapper">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-6">
                    <div className="card">
                      <div className="card-body">
                        <form
                          id="adddepartmentform"
                          className="needs-validation"
                          noValidate
                          onSubmit={e => handleSubmit(e, 2)}
                        >
                          <div className="row">
                            <div className="col-sm-12">
                              <div className="form-group">
                                <label>Youtube Embedded Code</label>
                                <textarea className="form-control" name="youtube_video" id="youtube_video" cols="10" rows="5" onChange={(e) => setFormData({ ...formData, value: e.target.value })} value={formData.value}></textarea>
                              </div>
                            </div>
                          </div>
                          <div className="form-group text-right">
                            <button
                              type="submit"
                              className="btn btn-primary waves-effect waves-light"
                            >
                              Submit
                            </button>
                          </div>
                        </form>
                        <div dangerouslySetInnerHTML={{ __html: fatchdata_2.value }}></div>
                        {/* {fatchdata_2.value} */}
                      </div>
                    </div>
                  </div>

                  {/* JCI UPLOAD VIDEO */}
                  {/* <div className="col-md-6">
                    <div className="card">
                      <div className="card-body">
                        <form
                          id="adddepartmentform"
                          className="needs-validation"
                          noValidate
                          onSubmit={e => handleSubmit(e, 1)}
                        >
                          {" "}
                          <div className="row">
                            <div className="col-sm-12">
                              <div className="form-group">
                                <label>Video Uploading JCI </label>
                                <input
                                  type="file"
                                  className="form-control"
                                  name="video"
                                  id="video"
                                  onChange={handleFileChange}
                                  accept="video/*"
                                  placeholder="Doctor Profile Pic"
                                />
                              </div>
                            </div>
                          </div>
                          <div className="form-group text-right">
                            <button
                              type="submit"
                              className="btn waves-effect waves-light"
                            >
                              Submit
                            </button>
                          </div>
                        </form>
                        <h3 className="mt-5">JCI Video Content</h3>
                        <video
                          autostart
                          loop
                          muted
                          autoPlay
                          src={IMAGE_URL + "Settings/" + fatchdata_1.value}
                          type="video/mp4"
                          style={{ width: "100%" }}
                        />
                      </div>
                    </div>
                  </div> */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ToastContainer autoClose={5000} />
    </div>
  );
};

export default uploading;



// WEBPACK FOOTER //
// ./src/component/admin/uploading.js